export default {
    'invoiceCarrier.title': 'Invoice Carrier',
    'invoiceCarrier.error.format.one': 'Invoice carrier barcode format is incorrect. Ex: Missing / or incorrect string length.',
    'invoiceCarrier.error.format.two': 'Please enter a barcode starting with / (e.g., /A123456)',
    'invoiceCarrier.save': 'Save',
    'invoiceCarrier.setting_complete': 'Carrier barcode setting completed',
} as Record<string, string>;
